import {
  pickInternalDestinationFromResolveResponse,
  resolveDestination,
} from "../services/destinationsApi";
import { getDestinationResolveHints } from "./resolveAttractionsDestinationId";

/**
 * מזהה יעד פנימי (internal_hotel_destinations.id) ל־hr_destination_id בחיפוש מלונות — מיושר עם זרם האטרקציות.
 * @returns {Promise<number | null>}
 */
export async function resolveCanonicalDestinationIdForHotelSearch(location, searchPhrase) {
  const hints = getDestinationResolveHints(location, searchPhrase);
  let lds = String(hints.lds_code || "").trim().toUpperCase();
  let name = String(hints.name || "").trim();

  if (lds.length < 2 && name.length < 2) {
    return null;
  }

  try {
    const data = await resolveDestination({
      lds_code: lds.length >= 2 ? lds : undefined,
      name: name.length >= 2 ? name : undefined,
    });
    if (!data || (data.status !== "ok" && data.status !== "partial")) {
      return null;
    }
    return pickInternalDestinationFromResolveResponse(data);
  } catch {
    return null;
  }
}
